import React from "react";
import StepsVerticalListV2 from "./stepsVerticalListV2";

export default function AppointmentHoverTooltip({ appointment, position, isVisible, onTooltipHover, onTooltipHoverEnd }) {
  if (!isVisible || !appointment) return null;

  // Calculate safe positioning to keep tooltip in viewport
  const safePosition = {
    x: Math.max(10, Math.min(position.x, (typeof window !== 'undefined' ? window.innerWidth : 1200) - 400)),
    y: Math.max(10, Math.min(position.y, (typeof window !== 'undefined' ? window.innerHeight : 800) - 200))
  };

  return (
    <>
      {/* Backdrop overlay for better contrast */}
      <div className="fixed inset-0 z-[9998] pointer-events-none" />
      
      <div
        data-component="AppointmentHoverTooltip"
        className="fixed z-[9999] bg-white/95 backdrop-blur-sm border-2 border-gray-300 rounded-xl shadow-2xl max-w-sm w-96 transition-all duration-200 ease-out animate-in fade-in zoom-in-95"
        style={{
          left: safePosition.x,
          top: safePosition.y,
          transform: 'translateY(-50%)',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(0, 0, 0, 0.1)',
        }}
        onMouseEnter={onTooltipHover}
        onMouseLeave={onTooltipHoverEnd}
      >
        {/* Arrow pointer */}
        <div 
          className="absolute w-4 h-4 bg-white/95 border-l-2 border-t-2 border-gray-300 rotate-45 -translate-x-2"
          style={{
            left: -8,
            top: '50%',
            transform: 'translateY(-50%) rotate(45deg)',
          }}
        />
        
        {/* Header */}
        <div className="p-4 border-b border-gray-200 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-t-xl">
          <h3 className="text-sm font-bold text-gray-900 truncate">
            {appointment.title || 'Appointment'}
          </h3>
          <p className="text-xs text-gray-600 mt-1 font-medium">
            {appointment.client?.firstName} {appointment.client?.lastName}
          </p>
          {appointment.service?.name && (
            <p className="text-xs text-blue-600 mt-1 bg-blue-100 px-2 py-1 rounded-full inline-block">
              {appointment.service.name}
            </p>
          )}
        </div>
        
        {/* Content with custom scrollbar */}
        <div 
          className="max-h-72 overflow-y-auto scrollbar-thin" 
          style={{
            scrollbarWidth: 'thin',
            scrollbarColor: '#9ca3af #f3f4f6'
          }}
        >
          <div className="p-3">
            <StepsVerticalListV2 appointment={appointment} />
          </div>
        </div>
        
        {/* Bottom gradient fade */}
        <div className="absolute bottom-0 left-0 right-0 h-8 bg-gradient-to-t from-white/95 to-transparent pointer-events-none rounded-b-xl" />
      </div>
    </>
  );
}